<template>    
    <div class="component">

<!-- NO:1 Slider Start -->
        <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active" data-bs-interval="10000">
                <img src="/img/slid1.jpg" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item" data-bs-interval="2000">
                <img src="/img/slid2.jpg" class="d-block w-100" alt="...">
                </div>
                <div class="carousel-item">
                <img src="/img/slid3.jpg" class="d-block w-100" alt="...">
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
        
<!-- NO:1 Slider End -->






<!-- NO:2 head-Card Start -->
        <div class="container row row-cols-1 row-cols-md-2 g-4" style="margin: 0 auto; width: 80%; padding-bottom: 50px;">
            <div class="col">
                <div class="card">
                <img src="/img/item1.jpg" class="card-img-top" alt="...">
                <div class="card-body">
                    <h5 class="card-title">𝗣𝗿𝗲𝗺𝗶𝘂𝗺 𝗖𝗼𝗹𝗹𝗲𝗰𝘁𝗶𝗼𝗻</h5>
                    <p class="card-text">The Premium Collection is a fusion of traditional elements with contemporary design.</p>
                    <p>
                      If you order online, you can get up to 10% discount on any product! and We always have various discounts in this company, so always try to stay with us. Stay tuned with like and follow now to get our offers.!
                    </p>
                    <p>
                      • Price: Ask for inbox.
                      <br>
                      • Size: XS, S, M, L, XL.
                      <br>
                      • Best Quality.
                      <br>
                      • Reasonable Price.
                      <br>
                      • Quickly Delivery.
                    </p>
                    <p>UPLOADED: <span style="opacity: 0.5; font-size: 16px;">20/12/2023</span></p>
                </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                <img src="/img/item2.jpg" class="card-img-top" alt="...">
                <div class="card-body">
                    <h5 class="card-title">𝗣𝗿𝗲𝗺𝗶𝘂𝗺 𝗖𝗼𝗹𝗹𝗲𝗰𝘁𝗶𝗼𝗻</h5>
                    <p class="card-text">The Premium Collection is a fusion of traditional elements with contemporary design.</p>
                    <p>
                      If you order online, you can get up to 10% discount on any product! and We always have various discounts in this company, so always try to stay with us. Stay tuned with like and follow now to get our offers.!
                    </p>
                    <p>
                      • Price: Ask for inbox.
                      <br>
                      • Size: XS, S, M, L, XL.
                      <br>
                      • Best Quality.
                      <br>
                      • Reasonable Price.
                      <br>
                      • Quickly Delivery.
                    </p>
                    <p>UPLOADED: <span style="opacity: 0.5; font-size: 16px;">24/12/2023</span></p>
                </div>
                </div>
            </div>
        </div>
<!-- NO:2 head-Card End -->


<!-- NO:3 Offcanvas Button Start -->
        <div class="container" style="text-align: center; margin-bottom: 50px;">
            <button class="btn btn-dark" style="background-color: #060606;" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop">
                Delivery Informations ⛟ 
            </button>

            <div class="offcanvas offcanvas-start" data-bs-backdrop="static" tabindex="-1" id="staticBackdrop" aria-labelledby="staticBackdropLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="staticBackdropLabel">Delivery & Delivery Informations</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
                <div style="text-align: left; margin-bottom: 50px;">
                <p>• Inside Dhaka Delivery Charge will be 70tk <br>• Outside Dhak Delivery Charge will be 150tk</p>
                <p style="opacity: 0.5;">Percel Delivery Time: 24hr - 48hr. (For Natural Disaster or any Unavoidable Circumstances Delivery may Delay) If our Delivery Man reach your customer locaion and didnt pickup the parcel, You have to pay the Delivery Charge.</p>
                </div>
                <div>
                    <img src="/img/delivery.png" alt="" style="width: 300px;">
                </div>
            </div>
            </div>
        </div>
<!-- NO:3 Offcanvas Button End -->


<!-- NO:4  Accordion Start -->
        <div class="container accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
                <h3 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    • Is anyone available to chat?
                </button>
                </h3>
                <div id="flush-collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">Thanks for contacting us, we will get back to you soon. Stay tuned to like our Facebook page to get more such new collections & Click here→ <a href="https://m.me/ibrand.bd.shop">Massage Now</a></div>
                </div>
            </div>
            <div class="accordion-item">
                <h3 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    • How much price?
                </button>
                </h3>
                <div id="flush-collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">Please give us the screenshot of the product you want to buy.</div>
                </div>
            </div>
            <div class="accordion-item">
                <h3 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                    • How is the Quality of your Products?
                </button>
                </h3>
                <div id="flush-collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">Thanks for contacting us, The quality of all our products is undoubtedly very good.</div>
                </div>
            </div>
        </div>
<!-- NO:4  Accordion End -->


<!-- NO:5 First Products Start -->
<div class="container fluid">
  <div class="px-lg-5">
    <!-- For demo purpose -->
    <div class="row py-5">
        <h2 style="text-align: center; font-size: 22px;"><b>UPCOMING</b> PRODUCTS - <b>2024</b></h2>
    </div>
    <!-- End -->
    <div class="row">
      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p1.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men's Slim Fit Panjabi</a></h5>
            <p class="small text-muted mb-0">Bring a touch of tradition to your wardrobe with this Premium Panjabi. Made from 100% soft and breathable cotton, it is perfect for any occasion.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANJABI</span></p>
              <div class="badge badge-danger px-3 rounded-pill font-weight-normal">Hot</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p2.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men's Slim Fit Panjabi</a></h5>
            <p class="small text-muted mb-0">Bring a touch of tradition to your wardrobe with this Premium Panjabi. Made from 100% soft and breathable cotton, it is perfect for any occasion.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANJABI</span></p>
              <div class="badge badge-primary px-3 rounded-pill font-weight-normal">Hot</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p3.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men's Slim Fit Panjabi</a></h5>
            <p class="small text-muted mb-0">Bring a touch of tradition to your wardrobe with this Premium Panjabi. Made from 100% soft and breathable cotton, it is perfect for any occasion.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANJABI</span></p>
              <div class="badge badge-warning px-3 rounded-pill font-weight-normal text-white">Hot</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p4.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men's Slim Fit Panjabi</a></h5>
            <p class="small text-muted mb-0">Bring a touch of tradition to your wardrobe with this Premium Panjabi. Made from 100% soft and breathable cotton, it is perfect for any occasion.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANJABI</span></p>
              <div class="badge badge-success px-3 rounded-pill font-weight-normal">Hot</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p5.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Waistcoat For Men</a></h5>
            <p class="small text-muted mb-0">Waist coat Manufactured and packed by Pashtush India Dry Clean Recommended.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">WAIST COAT</span></p>
              <div class="badge badge-primary px-3 rounded-pill font-weight-normal">Featured</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p6.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Waistcoat For Men</a></h5>
            <p class="small text-muted mb-0">Waist coat Manufactured and packed by Pashtush India Dry Clean Recommended.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">WAIST COAT</span></p>
              <div class="badge badge-warning px-3 rounded-pill font-weight-normal text-white">Featured</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p7.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Waistcoat For Men</a></h5>
            <p class="small text-muted mb-0">Waist coat Manufactured and packed by Pashtush India Dry Clean Recommended.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">WAIST COAT</span></p>
              <div class="badge badge-info px-3 rounded-pill font-weight-normal">Featured</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p8.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Waistcoat For Men</a></h5>
            <p class="small text-muted mb-0">Waist coat Manufactured and packed by Pashtush India Dry Clean Recommended.</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">WAIST COAT</span></p>
              <div class="badge badge-warning px-3 rounded-pill font-weight-normal text-white">Featured</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p9.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men’s Twill Chino Pant</a></h5>
            <p class="small text-muted mb-0">Zippered, Two side pockets, Two Back Welt Pockets. Twill Spandex Cotton</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANT</span></p>
              <div class="badge badge-danger px-3 rounded-pill font-weight-normal">Upcoming</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p10.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men’s Twill Chino Pant</a></h5>
            <p class="small text-muted mb-0">Zippered, Two side pockets, Two Back Welt Pockets. Twill Spandex Cotton</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANT</span></p>
              <div class="badge badge-primary px-3 rounded-pill font-weight-normal">Upcoming</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
      <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
        <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p11.jpg" alt="" class="img-fluid card-img-top">
          <div class="p-4">
            <h5> <a href="#" class="text-dark">Men’s Twill Chino Pant</a></h5>
            <p class="small text-muted mb-0">Zippered, Two side pockets, Two Back Welt Pockets. Twill Spandex Cotton</p>
            <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
              <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANT</span></p>
              <div class="badge badge-warning px-3 rounded-pill font-weight-normal text-white">Upcoming</div>
            </div>
          </div>
        </div>
      </div>
      <!-- End -->

      <!-- Gallery item -->
        <div class="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div class="bg-white rounded shadow-sm"><img src="/img/upcom-p12.jpg" alt="" class="img-fluid card-img-top">
            <div class="p-4">
                <h5> <a href="#" class="text-dark">Men’s Twill Chino Pant</a></h5>
                <p class="small text-muted mb-0">Zippered, Two side pockets, Two Back Welt Pockets. Twill Spandex Cotton</p>
                <div class="d-flex align-items-center justify-content-between rounded-pill bg-light px-3 py-2 mt-4">
                <p class="small mb-0"><i class="fa fa-picture-o mr-2"></i><span class="font-weight-bold">PANT</span></p>
                <div class="badge badge-success px-3 rounded-pill font-weight-normal">Upcoming</div>
                </div>
            </div>
            </div>
        </div>

    </div>
  </div>
</div>
<!-- End -->
<!-- NO:5 First Products End -->



<!-- NO:6 Last Card Start -->
      <div class="container card mb-3" style="max-width: 1200px; border: none; margin-top: 100px; margin-bottom: 100px;">
        <div class="row g-0">
          <div class="col-md-8">
            <div class="card-body">
              <h4 class="card-title">I BRAND BD</h4>
              <p class="card-text" style="width: 80%; opacity: 0.7; margin-top: 20px;">If you order online, you can get up to 10% discount on any product! and We always have various discounts in this company, so always try to stay with us. Stay tuned with like and follow now to get our offers!</p>
              <div class="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalToggleLabel">Offer Details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <img src="/img/popop.jpg" alt="" style="height: 468px;">
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-dark" style="background-color: #060606;" data-bs-target="#exampleModalToggle2" data-bs-toggle="modal">Next ↻</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal fade" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalToggleLabel2">Offer Details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <img src="/img/popop2.jpg" alt="" style="height: 468px;">
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-dark" style="background-color: #060606;" data-bs-target="#exampleModalToggle" data-bs-toggle="modal"> Back ↺</button>
                  </div>
                </div>
              </div>
            </div>
            <button class="btn btn-dark" data-bs-target="#exampleModalToggle" data-bs-toggle="modal" style="margin-top: 15px; background-color: #060606">Best offer Informations ツ</button>
            </div>
          </div>
          <div class="col-md-4">
            <img src="/img/lastimg.png" class="img-fluid rounded-start" alt="...">
          </div>
        </div>
      </div>
<!-- NO:6 Last Card End -->




    </div>
</template>

<script>
    export default {
        name: 'HomeCompo'
    }
</script>

<style>
.row {
    position: relative;
    margin: 0 auto;
}
.banner {
    background: #a770ef;
    background: -webkit-linear-gradient(to right, #a770ef, #cf8bf3, #fdb99b);
    background: linear-gradient(to right, #a770ef, #cf8bf3, #fdb99b);
}
a{
    text-decoration: none;
}
.badge{
    color: #060606;
    opacity: 0.6;
}
.col-xl-3{
  padding: 10px;
}
.btn:hover{
  opacity: 0.7;
  transition: all 0.2s ease-in-out;
}



@media only screen and (max-width: 768px) {
  .modal-body img{
      max-width: 340px;
      max-height: 340px;
  }
}
</style>